import {HammerGestureConfig} from '@angular/platform-browser';
import * as Hammer from 'hammerjs';

/**
 * Hammer js config that enables vertical swiping events
 * @class
 */
export class HammerSliderConfig extends HammerGestureConfig {

  /** @inheritdoc */
  overrides = {
    swipe: {direction: Hammer.DIRECTION_ALL},
  };
}


// WEBPACK FOOTER //
// ./src/app/shared/components/image/slider/hammer.config.ts